import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/image/35.png';
const _hoisted_1 = {
  class: "contact_us"
};
import { ref } from 'vue';
export default {
  __name: 'ContactUs',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "ercode"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }), _createElementVNode("span", null, "扫码二维码访问商城")], -1), _createElementVNode("div", {
        class: "text"
      }, [_createElementVNode("p", null, "联系我们"), _createElementVNode("p", null, "客服&举报电话：010-82697003"), _createElementVNode("p", null, "商家咨询热线：400-692-1123"), _createElementVNode("p", null, "商家咨询热线：15701190768"), _createElementVNode("p", null, "客服服务时间：9:00-18:00"), _createElementVNode("p", null, "荷鱼（北京）科技有限公司")], -1)]))]);
    };
  }
};